import { appScreen, Draw, Image, soundManager, useVoucherStore } from '@slot-nx/core'
import { memo, useCallback, useEffect, useRef } from 'react'
import { Container, Graphics } from '@pixi/react'
import { VoucherTotalWinTitle } from './VoucherTotalWinTitle'
import { VoucherTotalWinContent } from './VoucherTotalWinContent'
import { Container as PixiContainer } from 'pixi.js'
import { showPopupAnimation } from '../selectPopup/VoucherSelectPopup'
import { VoucherTotalWinButton } from './VoucherTotalWinButton'
import { VoucherSoundType } from '@slot-nx/core'

export const VoucherTotalWinPopup = memo(() => {
  const isShow = useVoucherStore(x => x.isShowVoucherTotalWinPopup)
  const [totalPayout] = useVoucherStore(x => [x.totalPayout])
  const popupRef = useRef<PixiContainer>()

  useEffect(() => {
    if (isShow && popupRef.current) {
      soundManager.play(VoucherSoundType.totalWinPopup)
      showPopupAnimation(popupRef.current)
    }
  }, [isShow])

  const maskDraw = useCallback<Draw>((g) => {
    g.clear()
    g.beginFill('black', 0.8)
    g.drawRect(0, 0, appScreen.width, appScreen.height)
    g.endFill()
  }, [])

  return (
    <Container name="VoucherTotalWinWrapper" visible={isShow}>
      <Graphics draw={maskDraw} eventMode="static" />
      <Container name="VoucherPopup_Bg">
        <Container name="VoucherTotalWinPopup" x={540} y={960} ref={(el) => { popupRef.current = el as PixiContainer }}>
          <Image name="voucher_total_win" image="voucher_Total_Win" width={942} height={1136} anchor={[0.5, 0.5]} x={0} y={-130} />
          <VoucherTotalWinTitle />
          <VoucherTotalWinContent totalPayout={totalPayout} />
          <VoucherTotalWinButton />
        </Container>
      </Container>
    </Container>

  )
})
